import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

/**
 * 註冊全域函數 intlFormat = (s) => intl.formatMessage(s)
 * 因為目前的react-intl版本（2.9.0），不支援useIntl()
 * 為了避免只是單純處理string，卻不必要的重複injectIntl各個Component的情況
 * use global comment if react-scripts is down 4.x, because eslintrc.json isn't work
 * @returns React.Component
 */
const InjectIntlFormatComponent = () => {
  const tempComponent = ({ intl }) => {
    global.intlFormat = s => intl.formatMessage(s);
    return <></>;
  };
  tempComponent.propTypes = {
    intl: PropTypes.shape({
      formatMessage: PropTypes.func.isRequired,
    }).isRequired,
  };
  const InjectComponent = injectIntl(tempComponent, {
    withRef: false,
  });
  return <InjectComponent />;
};
export default InjectIntlFormatComponent;
